import GxHorizontalLine from "@/app/components/common/actions/buttons/GxHorizontalLine";
import GxPrimaryButton from "@/app/components/common/actions/buttons/GxPrimaryButton";
import GxSecondaryButton from "@/app/components/common/actions/buttons/GxSecondaryButton";
import RequiredMessage from "@/app/components/webloading/errorHandling/RequiredMessage";
import { ICON_BASE_PATH } from "@/app/utils/config";
import { Button } from "@progress/kendo-react-buttons";
import type { ReactNode } from "react";

interface DialogFooterProps {
  handleClose: () => void;
  handleFooterSubmit?: () => void;
  handleDeleteSubmit?: () => void;
  cancel?: string;
  submit?: string;
  delete?: string;
  type?: "button" | "submit";
  submitDisabled?: boolean;
  buttonloading?: boolean;
  requiredMessage?: string | null;
  altariqBtn?: string;
  confirmMessage?: ReactNode;
  HorizontalLine?: boolean;
  enableAgreeDisAgree?: boolean;
}

const DialogFooter: React.FC<DialogFooterProps> = ({
  handleClose,
  handleFooterSubmit,
  handleDeleteSubmit,
  delete: deleteLabel,
  cancel,
  submit,
  type,
  submitDisabled,
  buttonloading,
  requiredMessage,
  altariqBtn,
  confirmMessage,
  HorizontalLine,
  enableAgreeDisAgree,
}) => {
  const handleSubmit = () => {
    if (handleFooterSubmit) {
      handleFooterSubmit();
    }
  };
  const handleDelete = () => {
    if (handleDeleteSubmit) {
      handleDeleteSubmit();
    }
  };

  const submitButtonView = () => {
    return altariqBtn ? (
      <button
        onClick={handleSubmit}
        className="bg-[linear-gradient(84.64deg,#00C8AF_0%,#015AD7_41.05%,#000000_82.6%)] py-3 rounded-[30px] flex items-center"
      >
        <img src={`${ICON_BASE_PATH}al-thariq-icon.svg`} alt="alTariq_icon" />{" "}
        <span className="text-[white] gx-font-bold ms-2">
          {altariqBtn} using AlTareq
        </span>
      </button>
    ) : (
      submit && (
        <GxPrimaryButton
          handleSubmit={handleSubmit}
          label={submit}
          type={type}
          disabled={submitDisabled}
          isLoading={buttonloading}
        />
      )
    );
  };

  return (
    <div>
      {enableAgreeDisAgree === false && (
        <p className="text-[#222222] my-[10px] text-[14px] gx-font-semibold">
          {confirmMessage}
        </p>
      )}
      <div
        className={
          requiredMessage && requiredMessage !== ""
            ? "gx-dialog-actions gx-dialog-required"
            : "gx-dialog-actions"
        }
      >
        {requiredMessage && requiredMessage !== "" && (
          <div
            className={`gx-required-message-child ${confirmMessage ? "my-[0.3rem]" : ""}`}
          >
            <RequiredMessage message={requiredMessage} />
          </div>
        )}

        {HorizontalLine && <GxHorizontalLine />}
        {enableAgreeDisAgree ? (
          <div className="flex space-x-2">
            <div className="gx-dis-agree-btn-tc">
              <button
                onClick={handleClose}
                className="gx-dis-agree-btn-tc-inner gx-p16-b"
              >
                Disagree
              </button>
            </div>
            <div className="gx-agree-btn-tc">
              <button
                onClick={handleSubmit}
                className="gx-agree-btn-tc-inner gx-p16-b"
              >
                Agree
              </button>
            </div>
          </div>
        ) : (
          <div className="flex space-x-2">
            {cancel && (
              <GxSecondaryButton handleClose={handleClose} label={cancel} />
            )}

            {deleteLabel && (
              <GxSecondaryButton
                handleClose={handleDelete}
                label={deleteLabel}
              />
            )}

            {buttonloading ? (
              <Button
                disabled
                className="gx-dialog-action-button gx-submit-for-approval gx-h4-b"
              >
                <span className="gx-font-bold">Loading...</span>
              </Button>
            ) : (
              submitButtonView()
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default DialogFooter;
